import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const token = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : null

export const chatApi = createApi({
    reducerPath: 'chatApi',
    baseQuery: (fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/admin`, prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })),
    endpoints: (build) => ({
        getChats: build.query({
            query() {
                return {
                    url: '/chats',
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Chats']
        }),
        getChatByChatId: build.query({
            query({ id }) {
                return {
                    url: `/chats/messages/${id}`,
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Chat']
        }),
    })
});

export const { useGetChatsQuery, useGetChatByChatIdQuery, useLazyGetChatByChatIdQuery } = chatApi;